import { v4 as uuidv4 } from 'uuid';

/**
 * Utilities for the 1DS sink
 */
export namespace Utils {
  /**
   * Generates a new GUID. Could be used for SessionId.
   */
  export function newGuid(): string {
    return uuidv4();
  }
}
